module.exports = __webpack_public_path__ + "images/frontpage_infinite@3x.png?9f8b78fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_infinite@3x.png
// module id = 653
// module chunks = 7